export function compareTuple<T extends any[]>(t1: T, t2: T): boolean {
    return t1.length === t2.length
        ? t1.reduce((result, val, i) => result && val === t2[i], true)
        : false;
}
